/* eslint-disable no-nested-ternary */
/* eslint-disable arrow-body-style */
import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: flex-start;
`;

const IconImage = styled.img`
  width: 16px;
  margin-right: 8px;
`;

const Text = styled.div`
  font-family: 'Roboto';
  font-size: 14px;
  line-height: 17px;
  color: #505050;
`;

export const Checklist = ({ status, text }) => {
  return (
    <Container>
      <IconImage
        src={
          status === 'check'
            ? 'checkIconCheck.svg'
            : status === 'error'
            ? 'checkIconWrong.svg'
            : 'checkIconDisabled.svg'
        }
        alt="icon"
      />
      <Text>{text}</Text>
    </Container>
  );
};

export default Checklist;
